<template>
    <a-modal v-model:visible="modalConfig.visible" :title="modalConfig.title" @ok="handleOk">
        <a-form ref="formRef" :model="formState" :rules="rules" :label-col="{ style: { width: '110px' } }">
            <a-form-item label="负责人" name="recipient">
                <a-input v-model:value="formState.recipient" placeholder="负责人" allowClear></a-input>
            </a-form-item>
            <a-form-item label="根本原因" name="rootCauseAnalysis">
                <a-textarea auto-size v-model:value="formState.rootCauseAnalysis" placeholder="根本原因" allowClear></a-textarea>
            </a-form-item>
            <a-form-item label="临时措施" name="temporaryMeasures">
                <a-textarea auto-size v-model:value="formState.temporaryMeasures" placeholder="临时措施" allowClear></a-textarea>
            </a-form-item>
            <a-form-item label="闭环措施" name="closedLoopMeasures">
                <a-textarea auto-size v-model:value="formState.closedLoopMeasures" placeholder="闭环措施" allowClear></a-textarea>
            </a-form-item>
            <a-form-item label="确认执行" name="implementationMeasures">
                <a-textarea auto-size v-model:value="formState.implementationMeasures" placeholder="确认执行" allowClear></a-textarea>
            </a-form-item>
        </a-form>
    </a-modal> </template>
<script>
import { defineComponent, reactive, ref } from "vue";
import { saveRootCauseAnalysisTemplate } from '@/request/view/afterSale';

import { Toast, debounce } from "@/utils";
export default defineComponent({
    setup(props, context) {
        const formRef = ref();

        const formState = reactive({
            closedLoopMeasures: null,
            id: null,
            implementationMeasures: null,
            recipient: null,
            rootCauseAnalysis: null,
            temporaryMeasures: null
        });

        const rules = {
            closedLoopMeasures: [{ required: true, message: null, trigger: 'change' }],
            id: [{ required: true, message: null, trigger: 'change' }],
            implementationMeasures: [{ required: true, message: null, trigger: 'change' }],
            recipient: [{ required: true, message: null, trigger: 'change' }],
            rootCauseAnalysis: [{ required: true, message: null, trigger: 'change' }],
            temporaryMeasures: [{ required: true, message: null, trigger: 'change' }]
        };

        const modalConfig = reactive({
            visible: false,
            title: null,
        });

        const showModal = (type, options) => {
            const { title, data } = options;
            if (type === "update") {
                Object.keys(formState).forEach((key) => {
                    formState[key] = data[key];
                });
            }
            if (type === "insert") {

            }
            modalConfig.title = title;
            modalConfig.visible = true;
        };


        const handleCancel = () => {
            resetForm();
            modalConfig.title = null;
            modalConfig.visible = false;
        };

        const resetForm = () => {
            Object.keys(formState).forEach((key) => {
                formState[key] = null;
            });
            formRef.value.clearValidate();
        };

        const handleOk = debounce(() => {
            formRef.value
                .validateFields()
                .then((res) => {
                    saveRootCauseAnalysisTemplate(formState).then((res) => {
                        const type = res.code === 200 ? "success" : "warning";
                        Toast(type, res.message, 3);
                        handleCancel();
                        context.emit("handleUpdateTable");
                    });
                })
                .catch((err) => {
                    if (err && err.errorFields) {
                        const [errText] = err.errorFields[0].errors;
                        Toast("warning", errText, 3);
                    }
                });
        });

        return {
            rules,
            formRef,
            formState,
            modalConfig,
            showModal,
            handleCancel,
            handleOk,
        };
    },
});
</script>